export default {
  state: {
    visible: false,
  },
  mutations: {
    updateSessionExpired(state, visible) {
      return (state.visible = visible);
    },
  },
};
